import { Box, styled, SxProps } from "@mui/material";
import * as React from "react";
import { OrderProductType } from "../../../Core/Api/Types/order-product-type";
import { OrderTypeAlphaColor } from "../../../Utils/helpers";
import OrderProductIcon from "../OrderProductIcon/order-product-icon";

export type OrderThumbnailProps = {
  sx?: SxProps;
  className?: string;
  type: OrderProductType;
  size?: "x-large" | "large" | "medium" | "small" | "x-small";
};

const OrderThumbnail: React.FC<OrderThumbnailProps> = (props) => (
  <StyledBox {...props}>
    <OrderProductIcon type={props.type} />
  </StyledBox>
);

export default OrderThumbnail;

const StyledBox = styled(Box, { shouldForwardProp: (prop) => prop !== "size" && prop !== "type" })<{
  size?: OrderThumbnailProps["size"];
  type: OrderProductType;
}>(({ size, type }) => {
  let _size = 56;
  let _iconSize = 28;
  let _borderRadius = 6;
  switch (size) {
    case "x-large":
      _size = 143;
      _iconSize = 64;
      _borderRadius = 12;
      break;
    case "large":
      _size = 96;
      _iconSize = 44;
      break;
    case "small":
      _size = 40;
      _iconSize = 18;
      _borderRadius = 3;
      break;
    case "x-small":
      _size = 32;
      _iconSize = 16;
      _borderRadius = 3;
      break;
  }

  const color = `radial-gradient(102.68% 102.68% at 102.68% 0%, ${OrderTypeAlphaColor(
    type,
    0.8
  )} 0%,  ${OrderTypeAlphaColor(type, 0.4)} 53.4%,  ${OrderTypeAlphaColor(type, 0.3)} 100%)`;

  return {
    width: _size,
    height: _size,
    background: color,
    borderRadius: _borderRadius,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ".MuiSvgIcon-root": {
      fontSize: _iconSize,
    },
  };
});
